import { useState, useEffect, useRef } from 'react';
import { getUserProfileApi } from '../services/authApi/userApi';
import { toastNotify } from '../utils/toastNotify';
import { addUserData } from '../store/reducer/accountSlice';
import { useDispatch, useSelector } from 'react-redux';

// Module-level flag: ensures only one in-flight profile request exists at a time,
// even when multiple components call useGetUserProfile simultaneously on the same page.
let profileFetchInProgress = false;

const useGetUserProfile = () => {
  const [respMessage, setRespMessage] = useState();
  const [loading, setLoading] = useState(false);
  const shouldLog = useRef(true);
  const dispatch = useDispatch();
  const existingUserData = useSelector((state) => state.userData.userData);

  useEffect(() => {
    // Check if user is logged in before making API call.
    // Skip only if another instance is already fetching (concurrent mount guard).
    const accessToken = localStorage.getItem('access_token');
    if (shouldLog.current && accessToken && !profileFetchInProgress) {
      shouldLog.current = false;
      profileFetchInProgress = true;
      getUserProfile();
    }
  }, []);

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const resData = await getUserProfileApi();
      if (!resData.isError) {
        dispatch(
          addUserData({
            userData: {
              ...resData?.data?.user,
            },
            counter: resData?.data?.counter,
          })
        );
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
      setRespMessage(response?.data?.message);
    } finally {
      setLoading(false);
      profileFetchInProgress = false; // reset so the next page navigation can fetch
    }
  };
  return {
    userProfileData: existingUserData,
    respMessage,
    loading,
  };
};

export default useGetUserProfile;
